import React from 'react'
import styled from 'styled-components'
import 'chartjs-plugin-datalabels'
import get from 'lodash/get'
import { MixedChartTable } from './mixed-chart-table'
import AlignedComponent from './aligned-component'

class SummaryTable extends React.Component {
  render() {
    return (
      <AlignedComponent padding={ 0 }>
        <Wrapper style={ { height: '100%', marginRight: 50 } }>
          <MixedChartTable
            efficiencySummary={ get(this.props, 'efficiencySummary') }
            widthLeft={ get(this.props, 'widthLeft') }
          />
        </Wrapper>
      </AlignedComponent>

    )
  }
}

SummaryTable.propTypes = {
}
SummaryTable.defaultProps = {
}

export default SummaryTable

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 500px;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/summary-table.js